module.exports = __webpack_public_path__ + "static/media/facebook.71478064.svg";